import React from "react"
import { Plus } from "lucide-react"
import { appTools, cn } from "lib/utils"

interface UnitTitleBlockProps {
  title:string
  className?:string
  children?:React.ReactNode
  [key:string]: any
}

export default function UnitTitleBlock({ title, className="", children, ...rest }:UnitTitleBlockProps){
  return (
    <div className={cn("w-full h-10 px-2 mt-6 mb-6 flex justify-between items-center bg-transparent border-y border-solid border-slate-700", className)}>
      <div className="w-7/12 h-10 flex justify-start items-center" {...rest}>
        <span className={cn("text-lg uppercase tracking-wider cursor-pointer")}>{ title }</span>
      </div>
      <div className="w-5/12 flex justify-end items-center">
        { children }
      </div>
    </div>
  )
}